import React from "react";
import "./index.scss";

const Modal = ({title, width, height, children, extra, close}) => {
  // Calculate max height considering viewport (leave 40px padding)
  const modalStyle = {
    width: width,
    ...(height && {
      maxHeight: height,
      height: 'auto'
    })
  };

  return (
    <div className="modal-container" onClick={(e) => {
      // Close on backdrop click
      if (e.target.className === 'modal-container' && close) {
        close();
      }
    }}>
      <div
        className="modal custom-modal fade show"
        style={modalStyle}
      >
        {title && (
          <div className="modal-header">
            {title} {extra}
            {close && (
              <button
                className="btn-modal-close"
                onClick={() => {
                  close();
                }}
              >
                &times;
              </button>
            )}
          </div>
        )}
        <div className="modal-content">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
